import {call, put} from "redux-saga/effects";
import {setLoading, setError, setConsultationList} from "../../slices/consultationSlice";
import {requestConsultationList} from "../requests/consultationService";

function* handleFetchConsultation(action) {
  const {page, type} = action.payload
  try {
    yield put(setLoading())
    const response = yield call(() => requestConsultationList({page: page, type: type}))
    yield put(setConsultationList(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export {handleFetchConsultation}